import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GuitarWorld: Site = {
  id: 'guitarworld',
  logo: 'svg/guitarworld.svg',
  label: 'Guitar World',
  analyticsName: 'guitarworld',
  hostname: 'guitarworld.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
